import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import result from '../../_interface/result';
import NebulaModuleBase from './module-base';
export var UpUnionPay = function (_NebulaModuleBase) {
    _inherits(UpUnionPay, _NebulaModuleBase);

    function UpUnionPay() {
        _classCallCheck(this, UpUnionPay);

        return _possibleConstructorReturn(this, (UpUnionPay.__proto__ || Object.getPrototypeOf(UpUnionPay)).apply(this, arguments));
    }

    _createClass(UpUnionPay, [{
        key: 'checkUnionPayIsInstalled',
        value: function checkUnionPayIsInstalled() {
            return this.generatePromiseByFunctionWithParams('unionPayIsInstalled', null);
        }
    }, {
        key: 'unionPayIsOrder',
        value: function unionPayIsOrder(param) {
            // return this.generatePromiseByFunctionWithParams('alipayAuthForAlipay', param);
            return new Promise(function (resolve, reject) {
                window.console.info('generate ' + 'unionPayOrder' + ' call ' + JSON.stringify(param));
                window.AlipayJSBridge.call('unionPayOrder', param, function (ret) {
                    window.console.info('bridge.call unionPayIsOrder' + JSON.stringify(ret));
                    if ((ret === null || ret === void 0 ? void 0 : ret.retCode) === '000000' || (ret === null || ret === void 0 ? void 0 : ret.retCode) === '00000') {
                        if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
                            resolve(new result('000000', '\u8C03\u7528\u51FD\u6570unionPayIsOrder\u6210\u529F', {
                                code: ret.retData.code,
                                data: {
                                    sign: '',
                                    cert_id: '',
                                    pay_result: '',
                                    tn: ''
                                }
                            }));
                        } else {
                            resolve(new result('000000', '\u8C03\u7528\u51FD\u6570unionPayIsOrder\u6210\u529F', ret.retData));
                        }
                    } else {
                        reject(new result(ret === null || ret === void 0 ? void 0 : ret.retCode, '\u8C03\u7528\u51FD\u6570unionPayIsOrder\u5931\u8D25,errMsg:' + (ret.retInfo || ret.message), ret.retData || ''));
                    }
                });
            });
        }
    }, {
        key: 'umsUnifyPayOrder',
        value: function umsUnifyPayOrder(param) {
            return this.generatePromiseByFunctionWithParams('umsUnifyPayOrder', param);
        }
    }]);

    return UpUnionPay;
}(NebulaModuleBase);